import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  initAnalytics,
  initMetaPixel,
  startPageViewTracking,
  registerGlobalErrorTracking,
} from './lib/analytics';
import { initFrontendObservability } from './lib/observability';
import { registerChunkRecovery } from './lib/chunkRecovery';

registerChunkRecovery();
initFrontendObservability();
initAnalytics();
initMetaPixel();
startPageViewTracking();
registerGlobalErrorTracking();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



